import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCategory } from "../../services/categories";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useUpdateCategory = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateCategory,
        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },
        onSuccess: (status) => {
            if (status === 200) {
                indicators.setIsProcessRunning(false);
                queryClient.invalidateQueries({ queryKey: ['categories'] });
                toast.success("Category updated successfully");
            }
        },
        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            indicators.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
}

export default useUpdateCategory;